import { render, staticRenderFns } from "./advertiserManageEdit.vue?vue&type=template&id=24bc0964&scoped=true"
import script from "./advertiserManageEdit.vue?vue&type=script&lang=js"
export * from "./advertiserManageEdit.vue?vue&type=script&lang=js"
import style0 from "./advertiserManageEdit.vue?vue&type=style&index=0&id=24bc0964&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bc0964",
  null
  
)

export default component.exports